var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: _vm.has_redemptions
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "p",
              {
                staticClass: "caption",
                class: _vm.$v.description.$error ? "text-negative" : ""
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("description")) +
                    "\n            "
                )
              ]
            ),
            _c("q-editor", {
              ref: "description",
              attrs: {
                error: _vm.$v.description.$error,
                toolbar: [
                  ["bold", "italic", "strike", "underline"],
                  ["left", "center", "right", "justify"],
                  ["link", "upload"],
                  [
                    {
                      label: null,
                      icon: "fas fa-font",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "code"]
                    },
                    {
                      label: null,
                      icon: "fas fa-text-height",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: [
                        "size-1",
                        "size-2",
                        "size-3",
                        "size-4",
                        "size-5",
                        "size-6",
                        "size-7"
                      ]
                    },
                    "removeFormat"
                  ],
                  ["quote", "unordered", "ordered"]
                ],
                definitions: {
                  bold: { label: null, icon: "fas fa-bold" },
                  italic: { label: null, icon: "fas fa-italic" },
                  strike: { label: null, icon: "fas fa-strikethrough" },
                  underline: { label: null, icon: "fas fa-underline" },
                  left: { label: null, icon: "fas fa-align-left" },
                  center: { label: null, icon: "fas fa-align-center" },
                  right: { label: null, icon: "fas fa-align-right" },
                  justify: { label: null, icon: "fas fa-align-justify" },
                  link: { label: null, icon: "fas fa-link" },
                  removeFormat: { label: null, icon: "fas fa-eraser" },
                  quote: { label: null, icon: "fas fa-quote-right" },
                  unordered: { label: null, icon: "fas fa-list-ul" },
                  ordered: { label: null, icon: "fas fa-list-ol" }
                }
              },
              on: { input: _vm.$v.description.$touch },
              model: {
                value: _vm.description,
                callback: function($$v) {
                  _vm.description = $$v
                },
                expression: "description"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-xs-12",
            class: _vm.reward_product_type !== "voucher" ? "" : "col-sm-6"
          },
          [
            _c("q-select", {
              ref: "reward_product_type",
              attrs: {
                "float-label": _vm.$t("type"),
                options: _vm.reward_product_type_list,
                disable: _vm.has_redemptions || _vm.reward_id != 0
              },
              model: {
                value: _vm.reward_product_type,
                callback: function($$v) {
                  _vm.reward_product_type = $$v
                },
                expression: "reward_product_type"
              }
            })
          ],
          1
        ),
        _vm.reward_product_type === "voucher"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 row items-center" },
              [
                _c("q-checkbox", {
                  staticClass: "q-mx-auto",
                  attrs: {
                    val: true,
                    label: _vm.$t("must_be_approved"),
                    disable: _vm.has_redemptions
                  },
                  model: {
                    value: _vm.must_be_approved,
                    callback: function($$v) {
                      _vm.must_be_approved = $$v
                    },
                    expression: "must_be_approved"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.reward_product_type === "voucher"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "p",
                  {
                    staticClass: "caption",
                    class: _vm.$v.redeem_instructions.$error
                      ? "text-negative"
                      : ""
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("redeem_instructions")) +
                        "\n            "
                    )
                  ]
                ),
                _c("q-editor", {
                  ref: "redeem_instructions",
                  attrs: {
                    error: _vm.$v.redeem_instructions.$error,
                    toolbar: [
                      ["bold", "italic", "strike", "underline"],
                      ["left", "center", "right", "justify"],
                      ["link", "upload"],
                      [
                        {
                          label: null,
                          icon: "fas fa-font",
                          fixedLabel: true,
                          fixedIcon: true,
                          list: "no-icons",
                          options: [
                            "p",
                            "h1",
                            "h2",
                            "h3",
                            "h4",
                            "h5",
                            "h6",
                            "code"
                          ]
                        },
                        {
                          label: null,
                          icon: "fas fa-text-height",
                          fixedLabel: true,
                          fixedIcon: true,
                          list: "no-icons",
                          options: [
                            "size-1",
                            "size-2",
                            "size-3",
                            "size-4",
                            "size-5",
                            "size-6",
                            "size-7"
                          ]
                        },
                        "removeFormat"
                      ],
                      ["quote", "unordered", "ordered"]
                    ],
                    definitions: {
                      bold: { label: null, icon: "fas fa-bold" },
                      italic: { label: null, icon: "fas fa-italic" },
                      strike: { label: null, icon: "fas fa-strikethrough" },
                      underline: { label: null, icon: "fas fa-underline" },
                      left: { label: null, icon: "fas fa-align-left" },
                      center: { label: null, icon: "fas fa-align-center" },
                      right: { label: null, icon: "fas fa-align-right" },
                      justify: { label: null, icon: "fas fa-align-justify" },
                      link: { label: null, icon: "fas fa-link" },
                      removeFormat: { label: null, icon: "fas fa-eraser" },
                      quote: { label: null, icon: "fas fa-quote-right" },
                      unordered: { label: null, icon: "fas fa-list-ul" },
                      ordered: { label: null, icon: "fas fa-list-ol" }
                    }
                  },
                  on: { input: _vm.$v.redeem_instructions.$touch },
                  model: {
                    value: _vm.redeem_instructions,
                    callback: function($$v) {
                      _vm.redeem_instructions = $$v
                    },
                    expression: "redeem_instructions"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("price"),
                error: _vm.$v.price.$error,
                disable: _vm.has_redemptions
              },
              on: { input: _vm.$v.price.$touch },
              model: {
                value: _vm.price,
                callback: function($$v) {
                  _vm.price = $$v
                },
                expression: "price"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("stock"),
                error: _vm.$v.qty_in_stock.$error,
                disable: _vm.reward_product_type == "voucher"
              },
              on: { input: _vm.$v.qty_in_stock.$touch },
              model: {
                value: _vm.qty_in_stock,
                callback: function($$v) {
                  _vm.qty_in_stock = $$v
                },
                expression: "qty_in_stock"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("max_redemptions_per_user"),
                disable: _vm.has_redemptions
              },
              model: {
                value: _vm.max_redemptions_per_user,
                callback: function($$v) {
                  _vm.max_redemptions_per_user = $$v
                },
                expression: "max_redemptions_per_user"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-12 q-mb-xl" }, [
        _c("div", { staticClass: "row gutter-sm flex" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("image")))
              ]),
              _c("uploader", {
                attrs: {
                  content_type: "images",
                  multiple: false,
                  cropper: true,
                  aspect_ratio: 52 / 29,
                  aspect_ratio_string: "52/29"
                },
                on: { fileUploaded: _vm.imageUploaded }
              }),
              _vm.reward_product_image
                ? _c(
                    "p",
                    { staticClass: "q-mt-md file-url" },
                    [
                      _c("q-icon", {
                        attrs: { name: "fal fa-check", color: "positive" }
                      }),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.reward_product_image,
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$truncateLink(_vm.reward_product_image)
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "row gutter-sm q-mb-xl" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-select", {
              ref: "timezone",
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                error: _vm.$v.timezone.$error,
                disabled: _vm.has_redemptions,
                clearable: ""
              },
              on: { input: _vm.$v.timezone.$touch },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "start_date",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("publish_date"),
                format: "DD/MM/YYYY HH:mm",
                clearable: ""
              },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "end_date",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("unpublish_date"),
                format: "DD/MM/YYYY HH:mm",
                clearable: ""
              },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: { val: true, label: _vm.$t("select_all_areas") },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("q-select", {
                      ref: "areas",
                      attrs: {
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.areas_list,
                        error: _vm.$v.areas.$error,
                        multiple: "",
                        chips: ""
                      },
                      on: { input: _vm.$v.areas.$touch },
                      model: {
                        value: _vm.areas,
                        callback: function($$v) {
                          _vm.areas = $$v
                        },
                        expression: "areas"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: { val: true, label: _vm.$t("all") },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles_list, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profiles.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profiles",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profiles.$error)
                              },
                              on: { input: _vm.$v.profiles.$touch },
                              model: {
                                value: _vm.profiles,
                                callback: function($$v) {
                                  _vm.profiles = $$v
                                },
                                expression: "profiles"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_groups",
                            attrs: {
                              options: _vm.user_groups_list,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_groups.$error,
                              multiple: "",
                              chips: ""
                            },
                            on: { input: _vm.$v.user_groups.$touch },
                            model: {
                              value: _vm.user_groups,
                              callback: function($$v) {
                                _vm.user_groups = $$v
                              },
                              expression: "user_groups"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      (!_vm.reward_id && _vm.reward_product_type !== "voucher") || _vm.reward_id
        ? _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("status")))
                ]),
                _c("q-btn-toggle", {
                  attrs: {
                    "toggle-color": _vm.getColorStatus,
                    options: _vm.statuses
                  },
                  model: {
                    value: _vm.status,
                    callback: function($$v) {
                      _vm.status = $$v
                    },
                    expression: "status"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_rewards" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }